import React, { useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { useLocation } from "react-router-dom";
import FlightIcon from "../../assets/img/plane.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconBack from "@material-ui/icons/ArrowBack";
import moment from "moment";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ContactDetail from "./ContactDetail";
import { connect, useDispatch, useSelector } from "react-redux";
import { toggleSignUp, getUserDetails } from "../../store/actions/user/User";
import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import { saveBooking } from "../../store/actions/flights/Flights";
import { uuid } from "uuidv4";
import PassengerList from "./components/Passenger Details/PassengerListV2";
import SelectedFlight from "./components/Selected Flight/SelectedFlight";
import Baggage from "./Baggage";
import PaymentCard from "./components/Payments Card/PaymentsCard";
import Loader from "../Loader/Loader";
import MySnackbar from "../MySnackBar";
import Footer from "./components/footer";
import { getCommision } from "../../helpers/general.helper";
import FareSummary from "./components/Fare Summary/FareSummary";
import AncillaryServices from "./components/AncillaryServices/AncillaryServices";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "2%",
    marginBottom: "2%",
    backgroundColor: "var(--white)",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
    marginTop: "2rem",
    maxWidth: "80%",
    margin: "0 auto",
    backgroundColor: "var(--backgroundcolor)",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "21%",
    },
  },
}));

let prevPrice = 0;
let prevSearchQuery = "";

function FlightBook(props) {
  const classes = useStyles();
  const search = useLocation().search;

  const passengers = useSelector((state) => state.flight.passengers);
  const selectedFlight = useSelector((state) => state.flight.selectedFlight);
  const journey = useSelector((state) => state.flight.journeyDetails);
  const selectedCurrency = useSelector((state) => state.flight.currency);

  // const {
  //   arrivalAirport,
  //   arrivalAirportName,
  //   baggage,
  //   departureAirport,
  //   departureAirportName,
  //   selectedDepartureDate,
  //   adults: defaultAdults,
  //   infants: defaultInfants,
  //   kids: defaultKids,
  // } = journey;
  const journeyType = new URLSearchParams(search).get("journeyType");
  const departureDate = new URLSearchParams(search).get("departureDate");
  const arrivalDate = new URLSearchParams(search).get("arrivalDate");
  const defaultAdults = new URLSearchParams(search).get("adults");
  const defaultKids = new URLSearchParams(search).get("kids");
  const defaultInfants = new URLSearchParams(search).get("infants");
  const flightClass = new URLSearchParams(search).get("flightClass");
  const defaultDepartureAirport = new URLSearchParams(search).get(
    "departureAirport"
  );
  const defaultArrivalAirport = new URLSearchParams(search).get(
    "arrivalAirport"
  );
  const [adults, setAdults] = useState(defaultAdults);
  const [kids, setKids] = useState(defaultKids);
  const [infants, setInfants] = useState(defaultInfants);

  const [flight, setFlight] = useState(null);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState({
    show: true,
    message: "",
    type: "",
  });

  const { flightId } = useParams();

  const dispatch = useDispatch();

  const ancillaryServices = useSelector(
    (state) => state.flight.ancillaryServices
  );

  const commissionedPrice =
    price +
    getCommision(price, props.commissionType, props.commissionValue) +
    getCommision(price, props.adminCommissionType, props.adminCommissionValue) +
    getCommision(0, props.adminCommissionType, props.adminCommissionValue) +
    getCommision(0, props.adminCommissionType, props.adminCommissionValue);

  useEffect(() => {
    // if (!selectedFlight) fetchData();

    setFlight(selectedFlight);
    setPrice(selectedFlight.total_price);
  }, [selectedFlight]);

  useEffect(() => {
    document.body.style.overflow = "visible";
  }, []);

  useEffect(() => {
    if (props.auth) {
      props.getUserDetails();
    }
    if (props.auth && localStorage.getItem("userLoginType") == "vendor") {
      props.getVendorDetails();
    }
  }, [props.auth]);

  function createUTCdateForISO(dateString) {
    const offset = new Date().getTimezoneOffset();
    const myDate = Date.parse(dateString) + offset * 60 * 1000;
    const dateAsISO = new Date(myDate).toISOString();

    return dateAsISO;
  }

  const proceedToPayment = async (token) => {
    let email = props.email;
    let phone = props.phone;
    let adults = props.adults;
    let kids = props.kids;
    let infants = props.infants;
    let selectedDepartureDate = props.selectedDepartureDate;
    let departureAirport = props.departureAirport;
    let arrivalAirport = props.arrivalAirport;
    const { listValid, passengers, location } = props;
    if (!listValid) {
      setShowSnackBar({
        show: true,
        message: "Please fill the mandatory fields in the Passenger list",
        type: "error",
      });
      return;
    }

    const adult_info = passengers.filter(
      (passenger) => passenger && passenger.category === "adult"
    );
    const child_info = passengers.filter(
      (passenger) => passenger && passenger.category === "child"
    );
    const infant_info = passengers.filter(
      (passenger) => passenger && passenger.category === "infant"
    );
    if (!adults) adults = adult_info.length;
    if (!kids) kids = child_info.length;
    if (!infants) infants = infant_info.length;
    if (
      !departureAirport &&
      location.search.split("&")[1].split("=")[0] == "departureAirport"
    )
      departureAirport = location.search.split("&")[1].split("=")[1];
    if (
      !arrivalAirport &&
      location.search.split("&")[2].split("=")[0] == "arrivalAirport"
    )
      arrivalAirport = location.search.split("&")[2].split("=")[1];
    if (
      !selectedDepartureDate &&
      location.search.split("&")[3].split("=")[0] == "departureDate"
    )
      selectedDepartureDate = location.search.split("&")[3].split("=")[1];
    if (adults === 0) {
      setShowSnackBar({
        show: true,
        message: "Add atleast one adult passenger to continue",
        type: "error",
      });
      return;
    }

    setSubmitLoader(true);

    let data = {
      adult_info: adult_info.map((data) => ({
        title: data.title,
        first_name: data.name,
        last_name: data.surname,
      })),
      child_info: child_info.map((data) => ({
        title: data.title,
        first_name: data.name,
        last_name: data.surname,
      })),
      infant_info: infant_info.map((data) => ({
        title: data.title,
        first_name: data.name,
        last_name: data.surname,
        dob: data.birthday,
        travelling_with: 1,
      })),
      total_pax: passengers.length,
      adults,
      child: kids,
      infant: infants,
      passenger_info: passengers,
      phone,
      email,
      ticket_id: flight.ticked_id || flight.id,
      total_price: commissionedPrice,
      useWallet: true,
      payment_token: token.id,
      date_from: moment(selectedDepartureDate).format("DD-MM-yyy"),
      fly_from: departureAirport,
      fly_to: arrivalAirport,
      ResultIndex: flight.ResultIndex,
      TraceId: flight.TraceId,
      mealRequests: Object.entries(ancillaryServices.meals)
        .map(([passengerId, mealData]) => {
          const passenger = passengers.find((p) => p.id === passengerId);
          const passengerIndex = passengers.indexOf(passenger) + 1;

          return {
            AirlineCode: mealData.AirlineCode,
            FlightNumber: mealData.FlightNumber,
            WayType: mealData.WayType,
            Code: mealData.Code,
            Description: mealData.Description,
            AirlineDescription: mealData.AirlineDescription,
            Quantity: mealData.Quantity,
            Currency: mealData.Currency,
            Price: mealData.Price,
            Origin: mealData.Origin,
            Destination: mealData.Destination,
            PassengerIndex: passengerIndex,
          };
        })
        .filter((meal) => meal.Code !== "Add No Meal ₹0"),
      baggageRequests: Object.entries(ancillaryServices.baggage)
        .map(([passengerId, baggageData]) => {
          const passenger = passengers.find((p) => p.id === passengerId);
          const passengerIndex = passengers.indexOf(passenger) + 1;

          return {
            AirlineCode: baggageData.AirlineCode,
            FlightNumber: baggageData.FlightNumber,
            WayType: baggageData.WayType,
            Code: baggageData.Code,
            Description: baggageData.Description,
            Weight: baggageData.Weight,
            Currency: baggageData.Currency,
            Price: baggageData.Price,
            Origin: baggageData.Origin,
            Destination: baggageData.Destination,
            PassengerIndex: passengerIndex,
          };
        })
        .filter((baggage) => baggage.Weight > 0),
    };

    axios
      .post("flights/save-booking-tbo", data)
      .then((res) => {
        // Clear ancillary services after successful booking
        dispatch({ type: "CLEAR_ANCILLARY_SERVICES" });

        setShowSnackBar({
          show: true,
          message: "Flight booked successfully!",
          type: "success",
        });
        if (localStorage.getItem("userLoginType") == "vendor") {
          props.history.push("/vendor/orders");
        } else {
          props.history.push("/flights");
        }
      })
      .catch((err) => {
        setShowSnackBar({
          show: true,
          message: "Something went wrong!",
          type: "error",
        });
      })
      .finally(() => {
        setSubmitLoader(false);
      });
  };
  const handleBack = () => {
    props.history.goBack();
  };

  const [fareRules, setFareRules] = useState(null);
  const [fareQuote, setFareQuote] = useState(null);
  const [ssrData, setSSRData] = useState(null);
  const [fareQuoteSuccess, setFareQuoteSuccess] = useState(false);

  const getFareRules = async () => {
    try {
      const response = await axios.post("flights/farerule-tbo", {
        ResultIndex: flight.ResultIndex,
        TraceId: flight.TraceId,
      });

      setFareRules(response);
      setFareQuoteSuccess(true);
    } catch (error) {
      console.error("Fare Rules fetch failed:", error);
    }
  };

  useEffect(() => {
    if (flight?.ResultIndex && flight?.TraceId) {
      getFareRules();
    }
  }, [flight]);

  return (
    <div className={classes.main}>
      <Grid
        container
        style={{ display: "flex", alignItems: "start" }}
        justifyContent="space-between"
      >
        <Grid
          xs="9"
          sm="9"
          className="flight-booking"
          style={{ paddingRight: "2rem" }}
        >
          <SelectedFlight flight={flight} loading={loading} />

          <PassengerList
            document_options={flight?.document_options}
            childs={kids}
            adults={adults}
            infants={infants}
            selectedCurrency={selectedCurrency}
            type="notKIWI"
          />

          {/* Remove the passenger map and render AncillaryServices once */}
          {fareQuoteSuccess && <AncillaryServices />}

          <PaymentCard
            adminCommission={{
              type: props.adminCommissionType,
              value: props.adminCommissionValue,
            }}
            flight={flight}
            onSuccess={proceedToPayment}
          />
          <Loader show={submitLoader} />
        </Grid>
        <FareSummary
          adminCommission={{
            type: props.adminCommissionType,
            value: props.adminCommissionValue,
          }}
          flight={flight}
        />
      </Grid>
      <Footer />
      <MySnackbar
        show={showSnackBar.show}
        onClose={() =>
          setShowSnackBar({ show: false, message: "", type: "info" })
        }
        message={showSnackBar.message}
        type={showSnackBar.type}
      />
    </div>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  let vendorCurrency;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
    vendorCurrency = state.vendor.vendorDetail.currency;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    auth: state.user.auth,
    userDetails: state.user.userDetails,
    passengers: state.flight.passengers,
    old_passengers: state.flight.old_pass,
    email: state.flight.email,
    phone: state.flight.phone,
    currency: state.flight.currency ? state.flight.currency : "",
    listValid: state.flight.passengerListValid,
    commissionType: commissionType,
    commissionValue: commissionValue,
    vendorCurrency,
    adminCommissionType,
    adminCommissionValue,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
  setSelectedFlight: (flight) => dispatch({ type: "SELECTED_FLIGHT", flight }),
  getUserDetails: () => dispatch(getUserDetails()),
  getVendorDetails: () => dispatch(getVendorDetails()),
  saveBooking: (data, session_id) => dispatch(saveBooking(data, session_id)),
});

export default connect(mapStateWithProps, mapDispatchToProps)(FlightBook);
